module.exports = __webpack_public_path__ + "static/img/book9.4281ad7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book9.jpg
// module id = fnAc
// module chunks = 1